import { useTranslation } from 'react-i18next';
import {
    IFilterOption,
    FilterTypes,
    useAppSelector,
    IOption,
} from '../../../../base';
import {
    overallScoreLabels,
    JobApplicationsTableFilterIds,
    JobApplicationStatuses,
} from '../../../../common';
import { jobsSelectors } from '../../../../actions';

export const useTableFilters = (): IFilterOption[] => {
    const { t } = useTranslation();
    const assignedJobList = useAppSelector(
        jobsSelectors.getAssignedJobListOptions
    );
    const trackableSourceOptions = useAppSelector(
        jobsSelectors.getTrackableSourcesOptions
    );

    const getJobApplicationStatusOptions = (): Array<IOption> => {
        return [
            {
                key: JobApplicationStatuses.new,
                label: t(`statuses.${JobApplicationStatuses.new}`),
                value: JobApplicationStatuses.new,
            },
            {
                key: JobApplicationStatuses.inReview,
                label: t(`statuses.${JobApplicationStatuses.inReview}`),
                value: JobApplicationStatuses.inReview,
            },
            {
                key: JobApplicationStatuses.hired,
                label: t(`statuses.${JobApplicationStatuses.hired}`),
                value: JobApplicationStatuses.hired,
            },
            {
                key: JobApplicationStatuses.withdrawn,
                label: t(`statuses.${JobApplicationStatuses.withdrawn}`),
                value: JobApplicationStatuses.withdrawn,
            },
            {
                key: JobApplicationStatuses.declined,
                label: t(`statuses.${JobApplicationStatuses.declined}`),
                value: JobApplicationStatuses.declined,
            },
        ];
    };

    return [
        {
            id: JobApplicationsTableFilterIds.publishedDate,
            label: t('jobApplicationsTable.applicationDate'),
            type: FilterTypes.datepicker_range,
        },
        {
            id: JobApplicationsTableFilterIds.status,
            label: t('jobApplicationsTable.applicationStatus'),
            type: FilterTypes.options,
            optionValues: getJobApplicationStatusOptions(),
        },
        {
            id: JobApplicationsTableFilterIds.score,
            label: t('jobApplicationsTable.matchScore'),
            type: FilterTypes.score_range,
            customRanges: overallScoreLabels,
        },
        {
            id: JobApplicationsTableFilterIds.jobId,
            label: t('jobApplicationsTable.job'),
            type: FilterTypes.options,
            optionValues: assignedJobList,
        },
        {
            id: JobApplicationsTableFilterIds.isSavedForLater,
            label: t('jobApplicationsTable.savedForLater'),
            type: FilterTypes.boolean,
        },
        {
            id: JobApplicationsTableFilterIds.tags,
            label: t('jobApplicationsTable.tags'),
            type: FilterTypes.tags,
        },
        {
            id: JobApplicationsTableFilterIds.source,
            label: t('jobApplicationsTable.source'),
            type: FilterTypes.options,
            optionValues: trackableSourceOptions,
        },
    ];
};
